import queryString from 'query-string'

function setQueryParamsToHash(queryParams: object): void {
  const [path = ''] = window.location.hash.split('?')
  window.location.hash = `${path}?${queryString.stringify(queryParams)}`
}

export default setQueryParamsToHash
